module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_desearch_close-57b1ad2530f88955b52e75ab5e474992.gif";